export enum LocationRequirement {
  Required = 'required',
  Preferred = 'preferred',
  Optional = 'optional'
}

export const DiscoveryNextStep = {
  EntraSso: 'entra_sso',
  NativeLogin: 'native_login'
} as const

export interface SsoExchangeRequest {
  AccessToken: string
  DeviceID: string
  Latitude: string
  Longitude: string
  BrowserType: string
  BrowserPlatform: string
  BrowserIsMobile: boolean
  BrowserMobileModel: string
  BrowserUserAgent: string
  GeoAccuracy: number
  AppVersion: string
  LocationServicesOptional: boolean
}

export interface DiscoveryResponse {
  validEmail: boolean
  entraEnabled: boolean
  tenantId: string
  nativeLogin: boolean
  mfaRequired: boolean
  locationRequirement: LocationRequirement
  nextStep: string
}
